import { Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { titleSx } from '../styles/styles'

type InputLabelProps = React.PropsWithChildren & {
  label: string
}

const InputLabel: React.FC<InputLabelProps> = ({ label, children }) => {
  return (
    <Stack spacing={'10px'} position={'relative'} width={'100%'}>
      <Typography variant='body2' sx={titleSx}>
        {label}
      </Typography>
      {children}
    </Stack>
  )
}

export default observer(InputLabel)
